import "../styles/HomeAbout.css";
import teamImage from "../assets/about.png"; // Replace with your image

function HomeAboutUs() {
  return (
    <section className="about-section">
      <div className="about-container">

        {/* Section Label */}
        <div className="section-tag">
          <span></span>
          <p>About Us</p>
        </div>

        {/* Heading */}
        <h2 className="about-heading">
          Independent thinking. Direct accountability. Real-world results.
        </h2>

        {/* Description */}
        <p className="about-description">
          We exist to create brands that matter and marketing that moves markets.
          Not brands that exist only in guidelines, but identities that shape
          perception, drive preference, and create commercial value. Not marketing
          that looks impressive in decks, but systems that generate pipeline,
          acquire customers, and accelerate growth.
        </p>

        {/* Team Image */}
        <div className="about-image-wrapper">
          <img src={teamImage} alt="Team" />
        </div>

        {/* Bottom Content */}
        <div className="expect-section">
          <h3>What Our Clients Can Expect</h3>

          <p>
            Engagements led by senior practitioners who bring both strategic
            depth and practical experience. Work that reflects genuine expertise,
            not templated solutions. Outcomes measured by market performance,
            not creative awards. Partnership built on accountability,
            transparency, and shared commitment to growth.
          </p>
        </div>

      </div>
    </section>
  );
}

export default HomeAboutUs;